import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/Data.context";

import "./ListProfiles.scss";
import { useNavigate } from "react-router-dom";

const ListProfiles = () => {
  const navigate: any = useNavigate();
  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Profiles",
        backButton: false,
        actionButton: true,
        nextPage: "/createProfile",
      },
    });

    _getProfiles();
  }, []);

  const [profiles, setProfiles] = useState([] as any[]);
  const _getProfiles = () => {
    const storageKey = "profiles";
    const profilesStorage: any = localStorage.getItem(storageKey);
    if (!profilesStorage) {
      navigate("/createProfile");
      return;
    }

    if (profilesStorage) {
      const profiles: any = JSON.parse(profilesStorage);
      setProfiles(profiles);
      return;
    }
  };

  return <>
    {profiles.length === 0 && <>No profiles found</>}

    {profiles.length > 0 && <>
      <ul className="list-group">

        {profiles.map((profile: any, index: number) => {
          return (
            <li key={`profile-${index}`} className="list-group-item">
              <div className="row">
                <div className="col-3 text-center">
                  <i className="fas fa-user-circle fa-3x"></i>
                </div>
                <div className="col">
                  <h4>{profile.firstName} {profile.lastName}</h4>
                  {profile.birth}
                </div>
              </div>
            </li>
          )
        })}

      </ul>
    </>}
  </>
};

export default ListProfiles;